import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import ListJobs from "./List";
import ShowJob from "./Show";
import { CareerCenterServicePath, JOBS } from "utils/constants";

import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  icon: <WorkHistoryIcon />,
  name: CareerCenterServicePath + JOBS,
  title: "Обяви за работа",
  list: <ListJobs />,
  show: <ShowJob />,
  showPermission: permissions.canPreviewJobs,
  permission: permissions.canPreviewJobs,
};
